import {data} from 'shared/components/Updates/data';
import {Update} from 'shared/components/Updates/entity/Update';

// NOTE: This will probably be a rtkquery or helper function that
// calls a rtkquery later
export const getUpdates = () => {
    return data as Update[];
};
